import script from "./One_article.vue?vue&type=script&setup=true&lang=ts"
export * from "./One_article.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__